

export function arrayForSelect(arr, keyName, valueKey) {
    return arr?.map((item, i) => ({
        name: item[keyName],
        value: valueKey === 'onlyName' ? item[keyName] : item[valueKey]
    }));
}
